import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import {
  meetingIsNotHeld,
  meetingIsEnd,
  meetingIsDelete,
  meetingIsBeingHeld,
  getPartyStatusOffLine,
  meetingIsQaEnable,
  meetingLock,
  meetingIsGuestMuteOverrideEnable,
  meetingWaitLineEnable,
  meetingWaitLineDisable,
  meetingWaitLineConnect,
  isNpConf,
  isByConf,
  isZhConf,
  recordValidDisable,
  recordValidEnable,
  dialoutAllowedDisable,
  dialoutAllowedEnable,
  dialoutAllowed8Enable
} from "@/model/conf/model";

import { spliceTelNumberKey } from "@/utils/validator";
export default new Vuex.Store({
  state: {
    listWidth: {
      online: 0,
      offline: 0,
      stash: 610
    },
    autoCall: false,
    roleMap: {},
    pinList: [],
    auth: {
      prod: "",
      token: "",
      privilege: ""
    },
    prod: null, // 访问产品类型
    billingCode: null,
    meetingName: "",
    meetingEnd: false,
    meeting: {
      billingCode: "", // 会议bc
      customerCode: "", // 客户编码
      name: "", // 会议名称
      beginTime: "", // 会议开始时间
      createTime: "", // 会议开始时间
      endTime: "", // 会议结束时间
      duration: "", // 会议时长 分钟
      bridgeName: "", // 平台归属，summit几？
      recordStatus: "", // 会议录音状态 0:未录音 1:正在录音 2:录音暂停
      muteStatus: "", // 0:会议未全体静音1:会议已全体静音
      lockStatus: "", // 会议锁定状态 0 会议未锁定 1 会议已锁定
      guestMuteOverride: "", // 当前会议静音状态 1：允许参会人自己解除；0:仅主持人可解除
      dialoutAllowedStatus: "", // 禁止呼叫
      firstJoinTime: "",
      recordValid: "", // 禁止录音
      chairmanPassword: "", // 主持人密码
      partyPassword: "", // 参与人密码
      encryptTel: "", // 是否加密电话
      parties: "",
      qaStatus: "",
      waitingLineStatus: "",
      status: "",
      result: ""
    },
    im: {
      appKey: "",
      roomId: "",
      token: "",
      accid: "",
      name: ""
    },
    imSelf: {},
    visibleIm: false,
    unReadMsgNum: 0,
    isGetImHis: false,
    imMsgList: [],
    // partyList: [],
    onlinePartyList: [],
    offlinePartyList: [],
    partyTalkList: [],
    qaList: [],
    upList: [],
    topList: [],
    qaFloorParty: null,
    search: {
      keyword: ""
    }
    // 认证信息
  },
  getters: {
    isMeetingEnd: state => state.meetingEnd,
    // onLineNumber: state => {
    //   let onLineNumber = 0;
    //   state.partyList.forEach(party => {
    //     if (custOnLine(party.status)) {
    //       onLineNumber++;
    //     }
    //   });

    //   return onLineNumber;
    // },
    encryptTelEnable: state => {
      return state.meeting.encryptTel == 1 ? true : false;
    },
    autoCall: state => state.autoCall,
    imSelfId: state => {
      return state.imSelf?.account;
    },
    //名字在前，id在后
    roleMapReverse: state => {
      let keys = Object.keys(state.roleMap);
      let obj = {};
      for (const key of keys) {
        obj[state.roleMap[key]] = key;
      }
      return obj;
    },
    roleArr: (state, getters) => {
      let arr = ["主持人", "主讲人", "嘉宾", "参会人"];
      let rs = [];
      for (const i of arr) {
        let key = getters.roleMapReverse[i];
        if (key != undefined) {
          rs.push({ name: i, key });
        }
      }

      return rs;
    },
    imInfo: state => state.im,
    authRole: state => {
      let { prod, privilege } = state.auth;
      let rs = "by";
      if (prod == "zh") {
        //0是客服
        if (privilege == 0) {
          rs = "zh_kf";
        } else {
          rs = "zh_kh";
        }
      }
      return rs;
    },
    searchKeyWord: state => state.search.keyword,
    isNpConf: state => isNpConf(state.auth.prod),
    isByConf: state => isByConf(state.auth.prod),
    isZhConf: state => isZhConf(state.auth.prod),
    chairmanRole: state => {
      // 主持人角色
      if (isNpConf(state.auth.prod)) {
        return 1;
      } else if (isByConf(state.auth.prod)) {
        return 0;
      } else if (isZhConf(state.auth.prod)) {
        return 2;
      }
    },
    presenterRole: state => {
      // 主讲人角色
      if (isNpConf(state.auth.prod)) {
        return 0;
      } else if (isByConf(state.auth.prod)) {
        return 1;
      } else if (isZhConf(state.auth.prod)) {
        return 1;
      }
    },
    presenterInParty: (state, getters) => {
      // for (let party of state.partyList) {
      //   if (getters.presenterRole === party.role && custInParty(party.status)) {
      //     return true;
      //   }
      // }
      for (let party of state.onlinePartyList) {
        if (getters.presenterRole === party.role) {
          return true;
        }
      }
      return false;
    },
    chairmanInParty: (state, getters) => {
      // for (let party of state.partyList) {
      //   if (getters.chairmanRole == party.role && custInParty(party.status)) {
      //     return true;
      //   }
      // }
      for (let party of state.onlinePartyList) {
        if (getters.chairmanRole == party.role) {
          return true;
        }
      }
      return false;
    },
    meetingInfo: state => state.meeting,
    // partyListInfo: state => state.partyList,
    onlinePartyListInfo: state => state.onlinePartyList,
    offlinePartyListInfo: state => state.offlinePartyList,
    partyIdList: state => {
      const partyIdList = {};
      // state.partyList.forEach(party => {
      //   partyIdList[party.id] = party;
      // });
      state.onlinePartyList.forEach(party => {
        partyIdList[party.id] = party;
      });
      return partyIdList;
    },
    custPhoneList: state => {
      const custPhoneList = {};
      // state.partyList.forEach(party => {
      //   const phone = spliceTelNumberKey(
      //     party.countryCode,
      //     party.areaCode,
      //     party.phone
      //   );
      //   custPhoneList[phone] = party;
      // });
      state.onlinePartyList.forEach(party => {
        const phone = spliceTelNumberKey(
          party.countryCode,
          party.areaCode,
          party.phone
        );
        custPhoneList[phone] = party;
      });
      state.offlinePartyList.forEach(party => {
        const phone = spliceTelNumberKey(
          party.countryCode,
          party.areaCode,
          party.phone
        );
        custPhoneList[phone] = party;
      });
      return custPhoneList;
    },
    meetingIsEnd: state => {
      return (
        meetingIsNotHeld(state.meeting.status) ||
        meetingIsEnd(state.meeting.status) ||
        meetingIsDelete(state.meeting.status)
      );
    },
    meetingIsLock: state => meetingLock(state.meeting.lockStatus),
    meetingIsStart: state => meetingIsBeingHeld(state.meeting.status),
    meetingQaEnable: state => meetingIsQaEnable(state.meeting.qaStatus),
    meetingGuestMuteOverrideEnable: state =>
      meetingIsGuestMuteOverrideEnable(state.meeting.guestMuteOverride),
    meetingWaitLineEnable: state =>
      meetingWaitLineEnable(state.meeting.waitingLineStatus),
    meetingWaitLineDisable: state =>
      meetingWaitLineDisable(state.meeting.waitingLineStatus),
    meetingWaitLineConnect: state =>
      meetingWaitLineConnect(state.meeting.waitingLineStatus),
    meetingName: state => {
      return state.meetingName;
    },
    prodInfo: state => {
      return state.prod;
    },
    authTokenInfo: state => {
      return state.auth.token !== "" ? state.auth.token : null;
    },
    billingcodeInfo: state => {
      return state.billingCode;
    },
    dialoutAllowed: state => {
      if (dialoutAllowedDisable(state.meeting.dialoutAllowedStatus)) {
        return false;
      } else if (
        dialoutAllowedEnable(state.meeting.dialoutAllowedStatus) ||
        dialoutAllowed8Enable(state.meeting.dialoutAllowedStatus)
      ) {
        return true;
      }
    },
    recordValid: state => {
      if (recordValidDisable(state.meeting.recordValid)) {
        return false;
      } else if (recordValidEnable(state.meeting.recordValid)) {
        return true;
      }
    }
  },
  mutations: {
    setListWidth(state, width) {
      state.listWidth["online"] = width;
      state.listWidth["offline"] = width;
    },
    setListWidthStash(state, width) {
      state.listWidth["stash"] = width;
    },
    setMeetingEnd(state, value) {
      state.meetingEnd = value;
    },
    setPinList(state, pinList) {
      state.pinList.splice(0, state.pinList.length, ...pinList);
    },
    setAutoCall(state, val) {
      state.autoCall = val;
    },
    setSearchKeyword(state, keyword) {
      state.search.keyword = keyword;
    },
    setPartyTalkList(state, list) {
      state.partyTalkList.splice(0, state.partyTalkList.length, ...list);
    },
    setQaList(state, qaList) {
      state.qaList.splice(0, state.qaList.length, ...qaList);
    },
    setUpList(state, upList) {
      state.qaList.splice(0, state.upList.length, ...upList);
    },
    setTopList(state, topList) {
      state.qaList.splice(0, state.topList.length, ...topList);
    },
    setQaFloorParty(state, qaFloorParty) {
      state.qaFloorParty = qaFloorParty;
    },
    setMeetingInfo(state, meeting) {
      state.meeting.billingCode = meeting.billingCode;
      state.meeting.customerCode = meeting.customerCode;
      state.meeting.name = meeting.name;
      state.meeting.beginTime = meeting.beginTime;
      state.meeting.createTime = meeting.createTime;
      state.meeting.endTime = meeting.endTime;
      state.meeting.duration = meeting.duration;
      state.meeting.bridgeName = meeting.bridgeName;
      state.meeting.recordStatus = meeting.recordStatus;
      state.meeting.muteStatus = meeting.muteStatus;
      state.meeting.lockStatus = meeting.lockStatus;
      state.meeting.guestMuteOverride = meeting.guestMuteOverride;
      state.meeting.dialoutAllowedStatus = meeting.dialoutAllowedStatus;
      state.meeting.firstJoinTime = meeting.firstJoinTime;
      state.meeting.recordValid = meeting.recordValid;
      state.meeting.chairmanPassword = meeting.chairmanPassword;
      state.meeting.partyPassword = meeting.partyPassword;
      state.meeting.encryptTel = meeting.encryptTel;
      state.meeting.parties = meeting.parties;
      state.meeting.qaStatus = meeting.qaStatus;
      state.meeting.waitingLineStatus = meeting.waitingLineStatus;
      state.meeting.status = meeting.status;
      state.meeting.result = meeting.result;
    },
    setMeetingWaitLineStatus(state, status) {
      state.meeting.waitingLineStatus = status;
    },
    setMeetingGuestMute(state, status) {
      state.meeting.guestMuteOverride = status;
    },
    setMeetingStatus(state, status) {
      state.meeting.status = status;
    },
    setMeetingQaStatus(state, status) {
      state.meeting.qaStatus = status;
    },
    setMeetingMuteStatus(state, status) {
      state.meeting.muteStatus = status;
    },
    setMeetingRecordStatus(state, status) {
      state.meeting.recordStatus = status;
    },
    setMeetingLockStatus(state, status) {
      state.meeting.lockStatus = status;
    },
    // replacePartyInfo(state, partyInfo) {
    //   state.partyList.splice(0, state.partyList.length, ...partyInfo);
    // },
    replaceOnlinePartyInfo(state, partyInfo) {
      // state.onlinePartyList.splice(
      //   0,
      //   state.onlinePartyList.length,
      //   ...partyInfo
      // );
      state.onlinePartyList = Object.freeze(partyInfo);
    },
    replaceOfflinePartyInfo(state, partyInfo) {
      // state.offlinePartyList.splice(
      //   0,
      //   state.offlinePartyList.length,
      //   ...partyInfo
      // );
      state.offlinePartyList = Object.freeze(partyInfo);
    },
    setRoleMap(state) {
      let rs = {};
      if (state.auth.prod == "by") {
        rs = {
          0: "主持人",
          1: "主讲人",
          3: "嘉宾",
          2: "参会人"
        };
      } else if (state.auth.prod == "zh") {
        rs = {
          2: "主持人",
          1: "主讲人",
          0: "参会人"
        };
      }
      state.roleMap = rs;
    },
    setAuth(state, auth) {
      // 设置认证信息
      state.auth.prod = auth.prod;
      state.auth.token = auth.token;
      state.auth.privilege = auth.privilege;
      this.commit("setRoleMap");
    },
    allCustHangup(state) {
      const partyStatusOffLine = getPartyStatusOffLine();
      state.onlinePartyList.forEach(party => {
        party.status = partyStatusOffLine;
      });
    },
    clearQa(state) {
      state.qaList.splice(0, state.qaList.length);
      state.qaFloorParty = null;
    }
  },
  modules: {}
});
